'use client';

import { type FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { Category } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { oneRowSliderLiveCasinoParams } from '@/helpers/games';
import { useGetCommonStore } from '@/store';
import { GamesSlider } from '../GamesSlider';

export const GamesSliderExclusive: FC = () => {
  const { t } = useTranslation('common');
  const useCommonStore = useGetCommonStore();

  const { gamesByCategory, fetchGames } = useCommonStore(
    useShallow((state) => ({
      gamesByCategory: state.gamesByCategory,
      fetchGames: state.fetchGames,
    }))
  );

  // Fetch and populate exclusive games if missing
  useEffect(() => {
    const fetchExclusiveGames = async () => {
      // Check if exclusive games data exists and has games
      if (gamesByCategory?.[Category.EXCLUSIVE]?.data?.length) {
        return;
      }

      // Fetch exclusive games
      const response = await fetchGames({
        filter: {
          categories: {
            identifiers: [Category.EXCLUSIVE],
          },
        },
        pageSize: 21,
        page: 1,
      });

      // Set the fetched data directly to the store
      if (response) {
        useCommonStore.setState({
          gamesByCategory: {
            ...gamesByCategory,
            [Category.EXCLUSIVE]: response,
          },
        });
      }
    };

    fetchExclusiveGames();
  }, [gamesByCategory, fetchGames, useCommonStore.setState]);

  return (
    <GamesSlider
      categoryId={Category.EXCLUSIVE}
      config={oneRowSliderLiveCasinoParams}
      dataTestId="exclusive-games-slider"
      icon={
        <ImageComponent
          alt="icon"
          height={24}
          src="/exclusiveIcon.webp"
          width={24}
        />
      }
      title={t(`common:gameCategories:${Category.EXCLUSIVE}`)}
    />
  );
};
